import ActionTypes from "../../../../constants/ActionTypes";
import { ICampaignOverviewState } from "./types";
import { CampaignConstants } from "../../../../constants/CampaignConstants";
import { ConsentConstants } from "../../../../constants/ConsentConstants";

const initialState: ICampaignOverviewState = {
  tp: null,
  optionName: '',
  terms: '',
  isActiveContactForMsisdn: false,
  cmUser: '',
  givenConsents: {
    globalConsent: false,
    cosmosConsent: false,
    socialNetworksOfferingsConsent: false,
    socialNetworksMatchingConsent: false
  },
  changedConsents: {
    globalConsent: ConsentConstants.statuses.ACCEPTED,
    cosmosConsent: ConsentConstants.statuses.ACCEPTED,
    socialNetworksOfferingsConsent: ConsentConstants.statuses.ACCEPTED,
    socialNetworksMatchingConsent: ConsentConstants.statuses.ACCEPTED
  },
  acceptanceStatus: CampaignConstants.acceptance.status.NOT_GIVEN,
  acceptanceRequestSmsStatus: false,
  acceptanceRequestEmailStatus: false,
  userTermsStatus: false,
  contactEmail: '',
  emailWasValidated: false,
  deliveryOption: CampaignConstants.deliveryOptions.SOFT_ELECTRO,
  selectedStoreId: null,
  offerId: null,
  optionId: null,
  cnlId: null,
  contractDuration: null,
  p2p: null,
  p2pDj: null,
  upsell: null,
  isDeliveryAddressSelected: false,
  addressData: null,
  eSim: null
};

const campaignOverviewReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_SOFT_OFFER_PACKAGE:
    return {
      ...state,
      tp: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_OPTION_NAME:
    return {
      ...state,
      optionName: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_TERMS:
    return {
      ...state,
      terms: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_IS_ACTIVE_CONTACT_FOR_MSISDN:
    return {
      ...state,
      isActiveContactForMsisdn: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_CM_USER:
    return {
      ...state,
      cmUser: action.payload
    };
  case ActionTypes.CAMPAIGN.CONSENT.SET_FROM_RESPONSE:
    return {
      ...state,
      givenConsents: action.payload
    };
  case ActionTypes.CAMPAIGN.CONSENT.SET_GLOBAL_CONSENT:
    return {
      ...state,
      changedConsents: {
        ...state.changedConsents,
        globalConsent: action.payload
      }
    };
  case ActionTypes.CAMPAIGN.CONSENT.SET_COSMOS_CONSENT:
    return {
      ...state,
      changedConsents: {
        ...state.changedConsents,
        cosmosConsent: action.payload
      }
    };
  case ActionTypes.CAMPAIGN.CONSENT.SET_SOCIAL_NETWORKS_OFFERING_CONSENT:
    return {
      ...state,
      changedConsents: {
        ...state.changedConsents,
        socialNetworksOfferingsConsent: action.payload
      }
    };
  case ActionTypes.CAMPAIGN.CONSENT.SET_SOCIAL_NETWORKS_MATCHING_CONSENT:
    return {
      ...state,
      changedConsents: {
        ...state.changedConsents,
        socialNetworksMatchingConsent: action.payload
      }
    };
  case ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_STATUS:
    return {
      ...state,
      acceptanceStatus: action.payload
    };
  case ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_REQUEST_SMS_STATUS:
    return {
      ...state,
      acceptanceRequestSmsStatus: action.payload
    };
  case ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_REQUEST_EMAIL_STATUS:
    return {
      ...state,
      acceptanceRequestEmailStatus: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_USER_TERMS_STATUS:
    return {
      ...state,
      userTermsStatus: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_CONTACT_EMAIL:
    return {
      ...state,
      contactEmail: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_ESIM_CARD:
    return {
      ...state,
      eSim: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_EMAIL_WAS_VALIDATED:
    return {
      ...state,
      emailWasValidated: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_DELIVERY_OPTION:
    return {
      ...state,
      deliveryOption: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_SELECTED_STORE_ID:
    return {
      ...state,
      selectedStoreId: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_OFFER_ADDITIONAL_DATA:
    return {
      ...state,
      offerId: action.payload.offerId,
      optionId: action.payload.optionId,
      cnlId: action.payload.cnlId,
      contractDuration: action.payload.contractDuration,
      p2p: action.payload.p2p,
      p2pDj: action.payload.p2pDj,
      upsell: action.payload.upsell,
      stopNonResident: action.payload.stopNonResident
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.SET_DELIVERY_ADDRESS:
    return {
      ...state,
      isDeliveryAddressSelected: true,
      addressData: action.payload
    };
  case ActionTypes.CAMPAIGN.OVERVIEW.CLEAR_DELIVERY_ADDRESS:
    return {
      ...state,
      isDeliveryAddressSelected: false
    };
  }
  return state;
};

export default campaignOverviewReducer;

